module.exports = __webpack_public_path__ + "img/line.2abf20bb.png";